import { ITreeGroup } from '../../tree.types'
import css from './treeGroupDropdown.module.css'
import { CSSProperties, useMemo, useRef } from 'react'
import ArrowDown from '@/assets/icons/arrowDown.svg?react'
import usePopup from '@/shared/hooks/usePopup'
import cn from '@/utils/cn'
import Tree from '@/shared/Tree'
import DropdownListItem from '@/shared/Dropdowns/DropdownListItem'
import DropdownFadeInPanel from '@/shared/Dropdowns/DropdownFadeInPanel'
import BreadcrumbPaths from '@/shared/BreadcrumbPaths'
import breadcrumbPathsUtils from '@/shared/BreadcrumbPaths/breadcrumbPaths.utils'

interface IProps<T extends Record<string, any>, ID extends string | number> {
  options: ITreeGroup<T, ID>[]
  optionNameGetter: (groupData: T) => string
  selectedOption?: ID
  onSelect?: (val: ID, name: string) => void
  name?: string
  title?: string
  wrapperStyle?: CSSProperties
  panelStyle?: CSSProperties
  disabled?: boolean
}

/**
 * Дропдаун, предалагающий выбрать одну из групп дерева
 * */
const TreeGroupDropdown = <T extends Record<string, any>, ID extends string | number>(props: IProps<T, ID>) => {
  const ref = useRef<HTMLInputElement>()
  const { open, setOpen } = usePopup(ref)

  const breadcrumbsPaths = useMemo(() => {
    return breadcrumbPathsUtils.getPathsGroup(props.selectedOption, props.options as any, (group) =>
      props.optionNameGetter(group.data)
    )
  }, [props.options, props.selectedOption])

  const renderInput = () => {
    if (props.selectedOption) {
      return (
        <div className="text-nm" style={{ width: '500px' }}>
          <BreadcrumbPaths paths={breadcrumbsPaths} styleMainPath={{ color: '#000000E0' }} />
        </div>
      )
    } else {
      return <div className={cn('text-nm', css.placeHolder)}>{props.title || 'Выберите группу'}</div>
    }
  }

  const renderGroup = (group: ITreeGroup<T, ID>) => {
    return (
      <DropdownListItem active={props.selectedOption === group.id} onClick={() => props.onSelect(group.id, props.name)}>
        <p className="text-nm" style={{ color: 'inherit' }}>
          {props.optionNameGetter(group.data)}
        </p>
      </DropdownListItem>
    )
  }

  return (
    <div
      className={css.wrapper}
      style={props.wrapperStyle}
      data-open={open}
      ref={ref}
      onClick={!props.disabled ? () => setOpen((prev) => !prev) : null}
    >
      <div>{renderInput()}</div>

      {!props.disabled && <ArrowDown data-open={open} className={css.arrow} />}
      <DropdownFadeInPanel open={open} style={props.panelStyle}>
        <Tree
          leafs={[]}
          groups={props.options}
          renderLeaf={null}
          renderGroup={renderGroup}
          styling={{ groupClassname: css.treeGroup }}
        />
      </DropdownFadeInPanel>
    </div>
  )
}

export default TreeGroupDropdown
